import { computed } from 'vue'

/**
 * Button events handling composable - giữ nguyên logic gốc
 * @param {Object} props - Component props
 * @param {Function} emit - Component emit function
 * @returns {Object} Event handlers
 */
export function useButtonEvents(props, emit) {
  /**
   * Hủy lan rộng event - giữ nguyên logic gốc
   * HTHIEP 09.02.2022
   */
  const cancelEvent = (e) => {
    if (e) {
      if (typeof e.preventDefault === 'function') {
        e.preventDefault()
      }

      if (typeof e.stopPropagation === 'function') {
        e.stopPropagation()
      }

      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation()
      }
    }
  }

  /**
   * Xử lý thò các event ra ngoài component - giữ nguyên logic gốc
   * HTHIEP 09.02.2022
   */
  const listeners = computed(() => {
    return {
      click: event => {
        // hủy lan rộng event
        cancelEvent(event)

        const deplay = window._appConfig?.buttonClickDeplayMilliseconds
        if (deplay && deplay > 0) {
          if (listeners._clicking) {
            return
          }

          listeners._clicking = true
          setTimeout(() => {
            delete listeners._clicking
          }, deplay)
        }
        
        // Giữ nguyên như file gốc - click event bị comment
        // emit('click', event)
      },
      mousedown: event => {
        // hủy lan rộng event
        cancelEvent(event)
        
        // Không emit mousedown event như file gốc
      },
      keydown: event => {
        // hủy lan rộng event
        cancelEvent(event)

        // trigger ra ngoài component
        emit('keydown', event)
      },
      focus: event => {
        // hủy lan rộng event
        cancelEvent(event)

        // trigger ra ngoài component
        emit('focus', event)
      },
    }
  })

  return {
    // Giữ listeners để tương thích với code gốc
    listeners
  }
}
